export const toastLife = 5000;
export const toastWithLinkLife = 7500;

export const contextMenuSeparator = {
  separator: true,
};
